<template>
  <div class="login">
    <top-nav />
    <div class="login-container">
      <div class="login-left">
        <img style="width:100%;height:auto;" src="login.jpg" />
      </div>

      <div class="login-right">
        <template v-if="model !== 'qrcode'">
          <svg-icon icon-class="code" @click.native="model =  'qrcode'" class="switch-icon" />
          <div class="login-switch">
            <span :class="{active: model==='default'}" @click="model = 'default'">账号登录</span>
            <span :class="{active: model==='code'}" @click="model = 'code'">验证码登录</span>
          </div>
        </template>
        <template v-else>
          <svg-icon icon-class="pc" @click.native="model =  'default'" class="switch-icon" />
          <div class="login-switch">
            <span class="active">扫码登录</span>
          </div>
        </template>
        <!-- 手机密码登录 -->
        <div v-if="model === 'default'" class="login-input">
          <div class="input-wrap">
            <input
              type="text"
              :class="{'err-input': errFields['phone']}"
              placeholder="手机号码/账号"
              v-model="phone"
              @keyup.enter="goNextStep('phone')"
            />
          </div>
          <div class="input-wrap">
            <input
              type="password"
              :class="{'err-input': errFields['password']}"
              maxlength="18"
              placeholder="密码"
              ref="password"
              v-model="password"
              @keyup.enter="goNextStep('password')"
            />
          </div>
          <div v-if="errNum >= 3" class="input-wrap">
            <Slider
              ref="slider"
              class="input-border"
              @failed="slideFail"
              :sfunc="slideCheck"
              @success="slideSuccess"
            />
          </div>
        </div>
        <!-- 验证码登录 -->
        <div v-if="model === 'code'" class="login-input">
          <input
            type="text"
            :class="{'err-input': errFields['phone']}"
            placeholder="手机号码"
            v-model="phone"
          />
          <div class="input-wrap">
            <Slider
              ref="slider"
              class="input-border"
              :sfunc="slideCheck"
              @failed="slideFail"
              @success="slideSuccess"
            />
          </div>
          <div>
            <input
              type="text"
              :class="{'err-input': errFields['code']}"
              maxlength="6"
              @change="doCheckCode"
              placeholder="短信验证码"
              v-model="code"
              class="code-input"
            />
            <button
              @click="doSendCode"
              :class="{'active-btn': canCode}"
              class="code-tip"
            >{{codeTip}}</button>
          </div>
        </div>

        <div v-if="model !== 'qrcode'" class="login-btn-container input-wrap">
          <button
            @click="doLogin"
            class="login-button"
            :class="{'active-btn': canDoLogin}"
          >登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
          <span class="error">{{errMsg}}</span>
        </div>
        <!-- 二维码扫码登录 -->
        <div v-else class="qr-div">
          <img class="login-qrcode" @click="newQrCode" :src="qrSrc" />
          <div v-show="!qrInUse" @click="newQrCode" class="login-qrcode-cover">
            <svg-icon icon-class="refresh" class="qr-refresh" />
          </div>
          <div class="tip-text">请使用APP扫码二维码登录</div>
        </div>
        <div class="login-tip-container">
          <template v-if="isShowRegister">
            <span>没有账号?</span>
            <span>|</span>
            <router-link class="a-text" to="/register">立即注册</router-link>
          </template>
          <router-link style="float:right;" class="a-text" to="/forget">忘记密码?</router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopNav from "../components/TopNav.vue";
import Footer from "../components/Footer.vue";
import Slider from "../components/Slider.vue";
import {
  getQrCode,
  loginByPasswd,
  sendCode,
  loginByCode,
  checkCode,
  checkToken,
  canRegister
} from "@/api/login";
import { isPoneAvailable, isvalidPassword } from "@/utils/validate";

const DEFAULT_TIP_TEXT = "获取验证码";
export default {
  name: "Login",
  components: {
    TopNav,
    Footer,
    Slider
  },
  props: {
    msg: String
  },
  data() {
    return {
      model: "default",
      codeTip: DEFAULT_TIP_TEXT,
      errFields: {},
      errMsg: "",
      canCode: false,
      phone: "",
      password: "",
      code: "",
      isSlide: false,
      isCode: false,
      qrSrc: "",
      sliderCode: "",
      errNum: 0,
      qrInUse: false
    };
  },

  destroyed() {
    if (this.tickTime) {
      clearInterval(this.tickTime);
    }
    if (this.qrTimer) {
      clearTimeout(this.qrTimer);
    }
  },

  watch: {
    phone() {
      this.clearErr();
    },
    password() {
      this.clearErr();
    },
    code() {
      this.clearErr();
    },
    model() {
      this.clearErr();
      if (this.model === "qrcode") {
        this.newQrCode();
      } else {
        if (this.qrTimer) {
          clearTimeout(this.qrTimer);
        }
      }
    }
  },

  computed: {
    isShowRegister() {
      return canRegister();
    },
    canDoLogin() {
      if (this.model === "default") {
        if (this.phone && this.password && isvalidPassword(this.password)) {
          if (this.errNum < 3) {
            return true;
          } else if (this.isSlide) {
            return true;
          }
        }
      } else if (this.model === "code") {
        if (isPoneAvailable(this.phone) && this.isCode) {
          return true;
        }
      }
      return false;
    }
  },

  methods: {
    goNextStep(current) {
      if (current === "phone") {
        this.$refs.password.focus();
      } else if (current === "password") {
        this.doLogin();
      }
    },
    doLogin() {
      this.clearErr();
      if (!this.phone) {
        this.$set(this.errFields, "phone", "手机号码必须提供");
      }
      if (this.model === "default") {
        if (!this.password) {
          this.$set(this.errFields, "password", "密码必须提供");
        } else if (!isvalidPassword(this.password)) {
          this.$set(this.errFields, "password", "密码不合法");
        }
      } else if (this.model === "code") {
        if (!this.code) {
          this.$set(this.errFields, "code", "验证码必须提供");
        }
      }
      let errFields = Object.keys(this.errFields);
      if (errFields.length > 0) {
        if (errFields.length === 1) {
          this.errMsg = this.errFields[errFields[0]];
        } else {
          this.errMsg = "信息填写错误";
        }
        return;
      }
      if (!this.canDoLogin) {
        return;
      }
      let response = undefined;
      if (this.model === "default") {
        response = loginByPasswd(this.phone, this.password);
      } else if (this.model === "code") {
        response = loginByCode(this.phone, this.code, this.sliderCode);
      }
      if (response) {
        response.then(res => {
          if (res.success) {
            this.$router.push({ path: "user", query: {} });
          } else {
            this.errMsg = res.msg;
            this.resetCheck();
          }
        });
      }
    },

    slideCheck() {
      if (this.model === "default") {
        if (!this.phone) {
          this.$set(this.errFields, "phone", "账号必须提供");
          this.errMsg = "账号必须提供";
          return false;
        } else {
          return true;
        }
      } else if (isPoneAvailable(this.phone)) {
        return true;
      } else {
        this.$set(this.errFields, "phone", "手机号码不正确");
        this.errMsg = "手机号码不正确";
        return false;
      }
    },
    /**
     * 生成新的二维码
     */
    newQrCode() {
      this.qrSrc = getQrCode("&isUrl=10&_t=" + new Date().getTime());
      this.qrInUse = true;
      if (this.qrTimer) {
        clearTimeout(this.qrTimer);
      }
      this.checkLoginStatus();
    },

    slideFail() {
      this.sliderCode = "";
      this.isSlide = false;
      this.canCode = false;
    },

    slideSuccess(data) {
      if (!this.canCode) {
        this.canCode = true;
      }
      this.sliderCode = data.sliderCode;
      this.isSlide = true;
    },

    clearErr(all = false) {
      this.$set(this, "errFields", {});
      if (all) {
        this.resetCheck();
      }
      this.errMsg = "";
    },

    resetCheck() {
      this.code = "";
      this.canCode = false;
      this.sliderCode = "";
      this.isSlide = false;
      let slider = this.$refs.slider;
      if (slider) {
        slider.clean();
      }
    },
    /**
     * 校验用户填写的验证码
     */
    doCheckCode() {
      if (this.code && this.code.length === 6) {
        checkCode("10", this.code, this.phone, this.sliderCode).then(res => {
          if (res.success) {
            this.isCode = true;
          } else {
            this.resetCheck();
            this.$nextTick(() => {
              this.errMsg = res.msg;
            });
          }
        });
      }
    },

    doSendCode() {
      if (this.canCode) {
        if (this.leftTime === undefined) {
          if (!isPoneAvailable(this.phone)) {
            this.$set(this, "errFields", {});
            this.$set(this.errFields, "phone", "手机号码错误");
            this.errMsg = "输入正确的手机号";
            return;
          }
          if (!this.isSlide) {
            this.errMsg = "拖动滑块后再获取";
            return;
          }
          sendCode(this.sliderCode, this.phone, "10")
            .then(res => {
              if (res.success) {
                this.leftTime = 60;
                this.codeTip = this.leftTime + "s后可重发";
                this.canCode = false;
                // 启动定时器
                this.tickTime = setInterval(() => {
                  if (this.leftTime > 0) {
                    this.leftTime = this.leftTime - 1;
                    this.codeTip = this.leftTime + "s后可重发";
                  } else {
                    this.leftTime = undefined;
                    this.codeTip = DEFAULT_TIP_TEXT;
                    clearInterval(this.tickTime);
                  }
                }, 1000);
              } else {
                this.errMsg = res.msg;
                this.resetCheck();
              }
            })
            .catch(() => {
              this.errMsg = "发送错误";
            });
          return;
        }
      }
    },

    /**
     * 定时验证二维码是否有效
     */
    checkLoginStatus() {
      // 校验会话是否已经登陆
      checkToken()
        .then(res => {
          if (res.success) {
            this.$router.push({ path: "user", query: {} });
          } else if (res.data === "40") {
            this.qrInUse = false;
          } else {
            this.qrTimer = setTimeout(() => {
              this.checkLoginStatus();
            }, 500);
          }
        })
        .catch(() => {
          this.qrTimer = setTimeout(() => {
            this.checkLoginStatus();
          }, 500);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  height: 100%;
}
.login-container {
  margin: 0 auto;
}
.login-left {
  background-color: white;
}

.login-right {
  text-align: left;
  position: relative;
  width: 100%;
  padding: 20px;
  border: 1px solid #cccccc;
}

.switch-icon {
  position: absolute;
  right: 3px;
  top: 3px;
  color: #0c9af4;
  font-size: 50px;
}

.login-switch span {
  margin-right: 20px;
  font-size: 16px;
  color: #666666;
  padding: 5px 5px;
  border-bottom: 3px solid white;
  cursor: default;
  user-select: none;
}

.login-switch span.active {
  color: #0c9af4;
  border-bottom-color: #0c9af4;
}

.login-input {
  margin-top: 20px;
}
.input-wrap {
  position: relative;
}
.login-input input {
  outline: none;
  border: 1px solid #cccccc;
  border-radius: 5px;
  line-height: 36px;
  box-sizing: border-box;

  padding: 0 10px;
  color: #333333;
}
.login-input input,
.input-border {
  margin-bottom: 16px;
  width: 280px;
}
.login-btn-container {
  padding-bottom: 30px;
}
.login-button {
  margin-top: 10px;
  width: 280px;
  line-height: 36px;
  background-color: #eef1f3;
  color: #666666;
  font-size: 14px;
  outline: none;
  border: 1px solid #cccccc;
  border-radius: 5px;
}
.login-button:focus {
  outline: none;
}

span.error {
  display: block;
  position: relative;
  font-size: 12px;
  top: 10px;
  color: red;
}

.login-tip-container {
  position: absolute;
  bottom: 10px;
  left: 20px;
  right: 50px;
}
.login-tip-container > span {
  font-size: 13px;
  margin-left: 5px;
  cursor: default;
}

.a-text {
  color: #0c9af4;
  font-size: 14px;
}

.tip-text {
  color: #333333;
}

.code-input {
  width: 150px !important;
}

.code-tip {
  position: relative;
  left: 10px;
  height: 36px;
  width: 120px;
  outline: none;
  border: 1px solid #cccccc;
  background-color: #eef1f3;
  border-radius: 5px;
  font-size: 14px;
}

.qr-div {
  text-align: center;
  position: relative;
  height: 280px;
}

.login-qrcode {
  width: 180px;
  height: 180px;
  margin: 30px 0 10px 0;
}

.login-qrcode-cover {
  position: absolute;
  width: 180px;
  height: 210px;
  line-height: 210px;
  text-align: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #efe9e957;
}
.qr-refresh {
  font-size: 50px;
  color: #efe9e957;
  position: relative;
  top: 10px;
}

.active-btn {
  background-color: #0c9af4;
  color: white;
}

.err-input {
  border-color: red !important;
}

@media only screen and (max-width: 600px) {
  .login-container {
    width: 100%;
  }
  .login-left {
    height: 180px;
    overflow: hidden;
  }
  .login-right {
    margin: 10px auto;
    width: 90%;
    border: 0;
  }
}

@media only screen and (min-width: 600px) {
  .login-container {
    margin-top: 30px;
    min-width: 516px;
  }
  .login-left {
    width: 80%;
    overflow: hidden;
    height: 340px;
    margin: 0 auto;
  }
  .input-wrap,
  .login-input {
    text-align: center;
  }
  .login-right {
    width: 80%;
    overflow: hidden;
    height: 340px;
    margin: 30px auto;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 992px) {
  .login-container {
    margin-top: 100px;
    width: 870px;
    height: 340px;
  }

  .login-left {
    float: left;
    width: 516px;
    height: 340px;
  }
  .login-right {
    margin-left: 516px;
    width: 354px;
    height: 100%;
  }
}
</style>
